const c = {
  name: "OmaniRial",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12.5,15.8l0.7,1.4c0.4,0.6,0.5,1.3,0.5,2v1.2c-0.1,1.1-0.6,2.1-1.3,2.9c-0.2,0.3-0.5,0.5-0.8,0.7
			c-0.3,0.2-0.6,0.3-1,0.3c-1-0.1-1.9-0.3-2.7-0.8l0.1-0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.8-0.1,1.6-0.4,2.3-0.9
			c0.7-0.5,1.2-1.2,1.5-1.9c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2-0.1-0.4-0.1-0.6c-0.4-0.8-0.8-1.6-1.3-2.3C12,16.6,12.2,16.2,12.5,15.8
			L12.5,15.8z"/>
		<path class="st0" d="M15.8,19.6c0.1-0.2,0.1-0.3,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.3-0.1,0.5-0.1c0.3,0,0.5,0.1,0.8,0.2
			c0.2,0.1,0.4,0.3,0.5,0.6c0.1,0.2,0.2,0.5,0.1,0.8c0,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0.1-0.5,0-0.8-0.1
			c-0.3-0.1-0.5-0.3-0.6-0.5c-0.2-0.2-0.2-0.5-0.2-0.8h0C15.7,19.9,15.8,19.7,15.8,19.6z"/>
		<path class="st0" d="M26,17.9c-1.2,0.5-2.4,1-3.6,1.7c-0.5,0.2-0.9,0.5-1.2,0.9c-0.3,0.4-0.5,0.9-0.6,1.4c0,1.8,1.9,3,4.8,3
			c0.9,0,1.8-0.1,2.7-0.3l0.1,0.2c-0.6,0.4-1.2,0.8-1.8,1.2c-0.6,0.2-1.2,0.3-1.8,0.3c-2.5,0-4.7-1.2-4.7-3.9c0-0.7,0.2-1.3,0.5-1.9
			c0.3-0.6,0.7-1.1,1.2-1.5c-1.1-0.8-1.6-1.4-1.6-2.3c0-0.6,0.2-1.1,0.4-1.6c0.2-0.4,0.5-0.7,0.8-0.9c0.3-0.2,0.7-0.3,1.1-0.4
			c0.5,0,0.9,0.1,1.3,0.4c0.4,0.2,0.7,0.6,1,0.9l-0.2,0.2C24.1,15.1,23.6,15,23,15c-1.2,0-2.1,0.6-2.1,1c0,0.4,0.3,0.9,0.9,1.3
			c0.4,0.3,0.8,0.5,1.2,0.6c0.2,0,0.4-0.1,0.6-0.2c1-0.5,1.9-0.9,2.8-1.2h0.1L26,17.9z"/>
		<path class="st0" d="M29.5,19.6c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.3,0.1,0.5,0.2,0.8c0.2,0.2,0.4,0.4,0.6,0.5c0.3,0.1,0.5,0.1,0.8,0.1
			c0.3-0.1,0.5-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.7c0-0.3,0-0.5-0.1-0.8c-0.1-0.2-0.3-0.5-0.5-0.6c-0.2-0.1-0.5-0.2-0.8-0.2
			c-0.2,0-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.2-0.4,0.3C29.7,19.2,29.6,19.4,29.5,19.6z"/>
		<path class="st0" d="M20,0c-4,0-7.8,1.2-11.1,3.4c-3.3,2.2-5.9,5.3-7.4,9C0,16-0.4,20,0.4,23.9c0.8,3.9,2.7,7.4,5.5,10.2
			c2.8,2.8,6.4,4.7,10.2,5.5C20,40.4,24,40,27.7,38.5c3.7-1.5,6.8-4.1,9-7.4C38.8,27.8,40,24,40,20c0-5.3-2.1-10.4-5.9-14.1
			S25.3,0,20,0z M20,38c-3.6,0-7-1.1-10-3c-3-2-5.3-4.8-6.6-8.1s-1.7-6.9-1-10.4C3,13,4.8,9.8,7.3,7.3C9.8,4.8,13,3,16.5,2.3
			c3.5-0.7,7.1-0.3,10.4,1C30.2,4.7,33,7,35,10c2,3,3,6.4,3,10c0,4.8-1.9,9.4-5.3,12.7C29.4,36.1,24.8,38,20,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as OmaniRial
};
